export const list = [
  // {
  //   id: 1,
  //   title: '我们用了 20 年改造水稻，只为了这根地下茎',
  //   titleEn: 'We Spent 20 Years Modifying Rice, All for This Underground Stem',
  //   tags: ['新基石研究员项目'],
  //   tagsEn: [],
  //   media: '《全是大问题》纪录片',
  //   mediaEn: 'Big Questions',
  //   vid: 'e41017rgizq',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 2,
  //   title: '看看草！草为什么不能长命百岁？',
  //   titleEn: `Look at Grass! Why Can't Grass Live for a Hundred Years?`,
  //   tags: ['新基石研究员项目'],
  //   tagsEn: [],
  //   media: '《全是大问题》纪录片',
  //   mediaEn: 'Big Questions',
  //   vid: 'a4101kjk1vz',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 3,
  //   title: '脑科学家们平时究竟对脑子做了什么？',
  //   titleEn: 'What Do Neuroscientists Actually Do to Brains?',
  //   tags: ['新基石研究员项目'],
  //   tagsEn: [],
  //   media: '《全是大问题》纪录片',
  //   mediaEn: 'Big Questions',
  //   vid: 'h41012aikcy',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 4,
  //   title: '为了折纸，她删除了那个点',
  //   titleEn: 'To Create Origami, She Removed That Dot',
  //   tags: ['科学探索奖'],
  //   tagsEn: [],
  //   media: '《全是大问题》纪录片',
  //   mediaEn: 'Big Questions',
  //   vid: 't4101hh2jg6',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  {
    id: 5,
    title: '实现神奇电子"集体舞"之后，35岁科学家称要无条件相信自己做的事',
    titleEn:
      'After Achieving the Magical Electron "Group Dance", 35-Year-Old Scientist Says to Believe Unconditionally in What You Do',
    tags: ['科学探索奖'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'k3173bu1xed',
    poster: `/resources/img/video/kxtsj.png`,
  },
  {
    id: 6,
    title: '癌细胞是如何转移的？清华神奇显微镜揭示全过程',
    titleEn: "How Do Cancer Cells Metastasize? Tsinghua's Amazing Microscope Reveals the Entire Process",
    tags: ['科学探索奖'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'p3172ydckxk',
    poster: `/resources/img/video/kxtsj.png`,
  },
  {
    id: 7,
    title: '不明原因反复发烧？基因侦探破解密码',
    titleEn: 'Unexplained Recurrent Fever? Genetic Detectives Crack the Code',
    tags: ['科学探索奖'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'b3172j6zkai',
    poster: `/resources/img/video/kxtsj.png`,
  },
  {
    id: 8,
    title: '徐通达：植物的一生都在卷',
    titleEn: 'XU Tongda: Plants Are Competing Their Whole Lives',
    tags: ['科学探索奖'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'y3172xkd9e4',
    poster: `/resources/img/video/kxtsj.png`,
  },
  {
    id: 9,
    title: '80后科学家周末在做什么',
    titleEn: 'What Do Post-80s Scientists Do on Weekends?',
    tags: ['企鹅科普'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'l3172ut34eq',
    poster: `/resources/img/video/qekp.png`,
  },
  {
    id: 10,
    title: '江小涓：积小善为大善 引导AI技术造福人类',
    titleEn: 'JIANG Xiaojuan: Accumulating Small Good Deeds into Great Good, Guiding AI Technology to Benefit Humanity',
    tags: ['新基石50²论坛'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'g3172zkn3no',
    poster: `/resources/img/video/50lt.png`,
  },
  {
    id: 11,
    title: '王晓东：有时候突破藏于交流处',
    titleEn: 'WANG Xiaodong: Sometimes Breakthroughs Hide in Communication',
    tags: ['新基石50²论坛'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'p31721ebrw7',
    poster: `/resources/img/video/50lt.png`,
  },
  {
    id: 12,
    title: '谢晓亮：破解人类基因组"天书" 用AI加速医药革命',
    titleEn:
      'XIE Xiaoliang: Deciphering the "Book of Heaven" of the Human Genome, Using AI to Accelerate the Medical Revolution',
    tags: ['新基石50²论坛'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'w3172jak2jr',
    poster: `/resources/img/video/50lt.png`,
  },
  {
    id: 13,
    title: '薛其坤：攻关世纪难题，还是好奇引领发现',
    titleEn: 'XUE Qikun: Tackling Century-Old Problems, Still Curiosity Leads Discovery',
    tags: ['新基石50²论坛'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'n3172oczvor',
    poster: `/resources/img/video/50lt.png`,
  },
  {
    id: 14,
    title: '科学家谈科研与管理：要潜心研究，也要建学术生态',
    titleEn: 'Scientists on Research and Management: Focus on Deep Research, But Also Build an Academic Ecosystem',
    tags: ['新基石50²论坛'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'z31725i8y73',
    poster: `/resources/img/video/50lt.png`,
  },
  {
    id: 15,
    title: '如何定义原创？杰出科学家解析"从0到1"',
    titleEn: 'How to Define Originality? Distinguished Scientists Analyze "From 0 to 1"',
    tags: ['新基石50²论坛'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'e3172d4cnry',
    poster: `/resources/img/video/50lt.png`,
  },
  {
    id: 16,
    title: '杰出科学家寄语青年！胆子大、脸皮厚、走自己的路',
    titleEn: `Distinguished Scientists\' Advice to the Youth! Be Bold, Be Thick-Skinned, and Forge Your Own Path`,
    tags: ['新基石50²论坛'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 't3172vweu85',
    poster: `/resources/img/video/50lt.png`,
  },
  {
    id: 17,
    title: '腾讯对科研支持的长期承诺：做原始创新的"沃土"与"阳光"',
    titleEn:
      'Tencent\'s Long-Term Commitment to Research Support: Being the "Fertile Soil" and "Sunshine" for Original Innovation',
    tags: ['新基石50²论坛'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'w3172zn2e6f',
    poster: `/resources/img/video/50lt.png`,
  },
  {
    id: 18,
    title: '腾讯SSV为什么要支持做前沿科普视频',
    titleEn: 'Why Tencent SSV Supports Creating Cutting-Edge Science Communication Videos',
    tags: ['科学探索奖', '企鹅科普'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'f3172iredfg',
    poster: `/resources/img/video/qekp.png`,
  },
  {
    id: 19,
    title: '获企鹅科普视频大赛最佳作品的马来西亚物理老师：眼里有光，科普获奖',
    titleEn:
      'he Malaysian Physics Teacher Who Won Best Work in the Tencent SciComm Video Competition: Eyes Full of Light, Awarded for Science Popularization',
    tags: ['科学探索奖', '企鹅科普'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'a3172z2ujvn',
    poster: `/resources/img/video/qekp.png`,
  },
  // {
  //   id: 20,
  //   title: '科探奖幕后揭秘',
  //   titleEn: 'Behind the Scenes of the Xplorer Prize',
  //   tags: ['科学探索奖'],
  //   tagsEn: [],
  //   media: '新基石科学基金会',
  //   mediaEn: 'New Cornerstone Science Foundation',
  //   vid: 'a3172pcflfb',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  {
    id: 21,
    title: '与过去相逢：谢谢我，一路走到这里',
    titleEn: 'Meeting the Past: Thank Me, for Making It All the Way Here',
    tags: ['科学探索奖'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'k31720uuo0m',
    poster: `/resources/img/video/kxtsj.png`,
  },
  {
    id: 22,
    title: '帮助盲人夺回"感知光的能力"',
    titleEn: 'Helping the Blind "Recapture" the Ability to Perceive Light',
    tags: ['科学探索奖'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'u31726hwz71',
    poster: `/resources/img/video/kxtsj.png`,
  },
  {
    id: 23,
    title: '科研青年的真实困境："叮咚，该交租了！"',
    titleEn: 'The Real Dilemma of Young Researchers: "Ding Dong, Time to Pay Rent!"',
    tags: ['科学探索奖'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'x3172t2wm52',
    poster: `/resources/img/video/kxtsj.png`,
  },
  // {
  //   id: 24,
  //   title: '我家有个大明星',
  //   titleEn: "There's a superstar living under our roof!",
  //   tags: ['科学探索奖'],
  //   tagsEn: [],
  //   media: '新基石科学基金会',
  //   mediaEn: 'New Cornerstone Science Foundation',
  //   vid: 'g3172f8lib4',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 25,
  //   title: '35亿年前的基因剪刀"再就业"：目标专治癌症基因和遗传病',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '人工洞洞板',
  //   mediaEn: '',
  //   vid: 'h12320879si',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 26,
  //   title: '我们还剩下多少"碳预算"？中国团队"底层代码"，争夺气候变化国际话语权',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '知识分子',
  //   mediaEn: '',
  //   vid: 'z12325bkfe7',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 27,
  //   title: '清华的"巨眼"，给宇宙拍3D电影',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '知识分子',
  //   mediaEn: '',
  //   vid: 'f1231goqdfn',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 28,
  //   title: '一脚刹车瘫痪整条高速？一条视频带你看懂"幽灵堵车"',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: 'Pastels',
  //   mediaEn: '',
  //   vid: 'h3171s1n5qy',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 29,
  //   title: '超级AI带我闯入量子禁区：80万超冷原子的革命！',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '墨子沙龙',
  //   mediaEn: '',
  //   vid: 'o1229k8u2wt',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 30,
  //   title: '150万公里外的宇宙之眼韦伯望远镜，如何窥探宇宙超130亿年的秘密？',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: 'POCKN',
  //   mediaEn: '',
  //   vid: 'd3171mqu3u7',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 31,
  //   title: '孙悟空的非凡之器金箍棒，能用现代的科技造出来吗？',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '上海科技馆',
  //   mediaEn: '',
  //   vid: 'z1229dyyb12',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 32,
  //   title: '女娲造人用泥土，为什么哪吒重塑金身却用藕粉？',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '硫光溢彩',
  //   mediaEn: '',
  //   vid: 'f1229655b8y',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 33,
  //   title: '保卫青藏高原：气候变暖下地质风险威胁或连环爆',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '中国气象爱好者',
  //   mediaEn: '',
  //   vid: 'f31711xtfdu',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 34,
  //   title: '在实验室里研究"古老折纸"，还能顺便解决一个几十年的航天难题？',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '上海科技馆',
  //   mediaEn: '',
  //   vid: 'm1228dspobz',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 35,
  //   title: '星系之死：谁谋杀了星系？宇宙警署锁定两大嫌犯',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '中国国家天文',
  //   mediaEn: '',
  //   vid: 'c1228bnhud5',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 36,
  //   title: '从"浪费"到"真香"！神奇薄膜"给光做翻译"，化身作物增产"光肥倍增器"！',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '任辉',
  //   mediaEn: '',
  //   vid: 't1228zwbb8l',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 37,
  //   title: '为什么我们要在雪山之巅的无人之境，建造一台望远镜？',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '原理',
  //   mediaEn: '',
  //   vid: 'o12284h2fbb',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 38,
  //   title: '揭秘PM2.5的阴谋：四大元凶逐个扒',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '清源派',
  //   mediaEn: '',
  //   vid: 'k31716lwgkx',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 39,
  //   title: '一键清除疼痛？人类能做到吗？',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '芝士条',
  //   mediaEn: '',
  //   vid: 'j1228tq9sss',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 40,
  //   title: '玉米也会被"霸凌"？看中国科学家团队如何解救它？',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '芝士条',
  //   mediaEn: '',
  //   vid: 'x12281nkq2z',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 41,
  //   title: '中国科学家破解"抗癌神药"紫杉醇生物合成的世界级难题',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '硫光溢彩',
  //   mediaEn: '',
  //   vid: 'z12286mk5yh',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 42,
  //   title: 'AI地图再精确？难敌人类空间魔法！网格细胞坐标系+内嗅皮层建模术让我化身活体导航仪！',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '大圆镜科普',
  //   mediaEn: '',
  //   vid: 'r1228yhsywp',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  {
    id: 43,
    title: '长身不老"的秘密就在线虫基因里？比酵母还节能，僵尸细胞清道夫解锁不老传奇',
    titleEn: '',
    tags: ['企鹅科普'],
    tagsEn: [],
    media: '大圆镜科普',
    mediaEn: '',
    vid: 'r1227hy2yw8',
    poster: `/resources/img/video/qekp.png`,
  },
  // {
  //   id: 44,
  //   title: '乘着流浪恒星离开银河系？超大质量黑洞竟是宇宙天体弹射器！',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '他山科普',
  //   mediaEn: '',
  //   vid: 't31701lncgs',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 45,
  //   title: '告别无差别灭杀！农药界最强"狙击手"上线',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '上海自然博物馆',
  //   mediaEn: '',
  //   vid: 'i3170dwg1ms',
  //   poster: `/resources/img/video/qekp.png`,
  // },
  // {
  //   id: 46,
  //   title: '想像壁虎一样"断尾再生"？科学家：在努力了！',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '模型师老原儿',
  //   mediaEn: '',
  //   vid: 'l1227sggcf0',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 47,
  //   title: '绝了！科学家给土壤菌群发 "工作证"，水稻狂增产，怎么做到的？',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '模型师老原儿',
  //   mediaEn: '',
  //   vid: 'j12272b6h99',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 48,
  //   title: '一滴咖啡如何改变工业？科学家揭秘液滴蒸发背后的惊人智慧',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '美丽科学BOS',
  //   mediaEn: '',
  //   vid: 'a1227r38p6q',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 49,
  //   title: '中国黑科技突破：让墙壁变镜子！中科大量子成像技术震惊世界',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '科学有故事汪诘',
  //   mediaEn: '',
  //   vid: 'x1227qsi1mw',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 50,
  //   title: '如何找到迄今银河系里的最小恒星？关键词：TMTS！',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: 'LTYCHO',
  //   mediaEn: '',
  //   vid: 'g1227baoo75',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 51,
  //   title: '我自制了"深空降温漆"，不用电让房子凉快4度！',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '皮卡悠',
  //   mediaEn: '',
  //   vid: 'c1227u96rdv',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 52,
  //   title: '太空最绝望一幕！空间站如果发生火灾，如何博得一线生机？',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '环球科学',
  //   mediaEn: '',
  //   vid: 'g31700ai75b',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 53,
  //   title: '航天黑科技，让我把太阳能板折起来！',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '皮卡悠',
  //   mediaEn: '',
  //   vid: 'y12276j6x4e',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 54,
  //   title: '颠覆认知！恐龙根本没灭绝？1.5亿年前的真飞鸟化石刚刚被发现',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '科学有故事汪诘',
  //   mediaEn: '',
  //   vid: 'a1226b0tk0o',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 55,
  //   title: '如果细胞"发烧"了，如何用温度计给细胞测温？方法藏在这种粉色钻石里',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '后视镜工作室',
  //   mediaEn: '',
  //   vid: 'z1226xusjrb',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 56,
  //   title: '从伽利略到全球组网：中国正为地球装上"宇宙之眼"！',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '天文笔记',
  //   mediaEn: '',
  //   vid: 'x1226dm48qp',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 57,
  //   title: '比飞机还快的高铁？三小时横跨中国！真空管道高温超导磁悬浮让我成了时间刺客！',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '出个远门儿',
  //   mediaEn: '',
  //   vid: 's12265r8wxz',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 58,
  //   title: '【科学音乐剧】胆汁淤积治好了，瘙痒却停不下来？冷冻电镜看到了瘙痒的开关',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '盐与雪菜',
  //   mediaEn: '',
  //   vid: 'g12267dpnfp',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 59,
  //   title: 'HALF：作为一个光源，长得像太极图也很合理吧',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '风云之声',
  //   mediaEn: '',
  //   vid: 'k1225931emm',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 60,
  //   title: '40分钟带你彻底看懂量子计算：量子效应如何突破计算的边界？｜漫士',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '漫士',
  //   mediaEn: '',
  //   vid: 'f3170b3li8i',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 61,
  //   title: '万亿分之一秒有多快？科学家用飞秒激光改写量子材料基因，拍摄电子随光起舞',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '量子学派',
  //   mediaEn: '',
  //   vid: 'c3170165asd',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 62,
  //   title: '驱动从年轻到衰老的发动机竟是母系遗传？衰老剧本跟父亲基本无关！',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '营养师顾中一',
  //   mediaEn: '',
  //   vid: 'l1224cpt3v6',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 63,
  //   title: '中国科学家在海拔5250米高原建造望远镜，瞄准宇宙诞生后第一声啼鸣',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '子乾',
  //   mediaEn: '',
  //   vid: 'y122404b3jj',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 64,
  //   title: '20瓦人脑 VS 几十万瓦AI：谁才是真正的超级智能？',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '小学科学SSR',
  //   mediaEn: '',
  //   vid: 'i1224zqszxs',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 65,
  //   title: '当生命代码写错字母、皮肤一碰就破，科学家如何"逆天改命"？',
  //   titleEn: '',
  //   tags: ['企鹅科普'],
  //   tagsEn: [],
  //   media: '豌豆Sir',
  //   mediaEn: '',
  //   vid: 'n3170n09blc',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  {
    id: 66,
    title: '王志珍院士寄语：像爱护眼睛一样爱护学术荣誉',
    titleEn: '',
    tags: ['科学探索奖'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'x3172jd97el',
    poster: `/resources/img/video/kxtsj.png`,
  },
  {
    id: 67,
    title: '浙大教授冯建东：一个分子的梦想和实践',
    titleEn: `ZJU Professor FENG Jiandong: One Molecule's Dream and Practice`,
    tags: ['科学探索奖'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'u3568az6feh',
    poster: `/resources/img/video/kxtsj.png`,
  },
  {
    id: 68,
    title: '川大教授张茹：逐梦地球深处',
    titleEn: `SCU Professor ZHANG Ru: Chasing Dreams Deep Within the Earth`,
    tags: ['科学探索奖'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'v3568x9t8zj',
    poster: `/resources/img/video/kxtsj.png`,
  },
  {
    id: 69,
    title: '北大教授伊成器：解码“生命之书”',
    titleEn: `PKU Professor YI Chengqi: Decoding the "Book of Life"`,
    tags: ['科学探索奖'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'y3568982kna',
    poster: `/resources/img/video/kxtsj.png`,
  },
  {
    id: 70,
    title: '清华教授周树云：创造万亿分之一秒的“奇迹”',
    titleEn: `Tsinghua Professor ZHOU Shuyun: Creating a "Miracle" in a Trillionth of a Second`,
    tags: ['科学探索奖'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'y3568xo3n3i',
    poster: `/resources/img/video/kxtsj.png`,
  },
  {
    id: 71,
    title: '生命起源于太空还是地球',
    titleEn: `Did Life Originate in Space or on Earth?`,
    tags: ['科学探索奖'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 't35683t5bsh',
    poster: `/resources/img/video/kxtsj.png`,
  },
  {
    id: 72,
    title: '天文学家地质学家抢着“认账”',
    titleEn: `Astronomers and Geologists Vying to "Claim Responsibility"`,
    tags: ['科学探索奖'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'p3568nxnimx',
    poster: `/resources/img/video/kxtsj.png`,
  },
  {
    id: 73,
    title: '王志珍：女性获奖人越来越多 此处可有掌声',
    titleEn: `SWANG Zhizhen: Growing Number of Female Awardees – A Round of Applause, Please!`,
    tags: ['科学探索奖'],
    tagsEn: [],
    media: '新基石科学基金会',
    mediaEn: 'New Cornerstone Science Foundation',
    vid: 'r3568sg4hws',
    poster: `/resources/img/video/kxtsj.png`,
  },
  // {
  //   id: 74,
  //   title: '青年科学家走红毯说梦想',
  //   titleEn: `Young Scientists Walk the Red Carpet and Share Their Dreams`,
  //   tags: ['科学探索奖'],
  //   tagsEn: [],
  //   media: '新基石科学基金会',
  //   mediaEn: 'New Cornerstone Science Foundation',
  //   vid: 'e3567c69oow',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 75,
  //   title: '',
  //   titleEn: `Aspiring Scientists, We Are Waiting for You`,
  //   tags: ['科学探索奖'],
  //   tagsEn: [],
  //   media: '新基石研究员项目',
  //   mediaEn: 'Tencent SSV',
  //   vid: 'c335093dt2r',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
  // {
  //   id: 76,
  //   title: '首批新基石受资助研究员名单公布',
  //   titleEn: `First Cohort of New Cornerstone Funded Investigators Announced`,
  //   tags: ['科学探索奖'],
  //   tagsEn: [],
  //   media: '新基石研究员项目',
  //   mediaEn: 'Tencent SSV',
  //   vid: 'n3370eoyf55',
  //   poster: 'https://static.xplorerprize.org/portalResource/award/images/index_banner_2022_v2.png',
  // },
];

export default list;
